module.exports = __webpack_public_path__ + "static/media/May_2026_5.a95d459c.webp";